import React, { useEffect, useState } from "react";
import useStyles from "./Styles";
import { Grid, Tabs, Tab, Icon } from "@material-ui/core";
import { useHistory } from "react-router";
import { listOfFeatureSettings, TabPanelData } from './utils'

import { useSelector } from "react-redux";
import userActions from "./actions";
// import appActions from "../app/actions";
import useIsDevUrl from "hooks/useIsDevUrl";
import TabPanel from "./TabPanel";

const ChartIcon = (props) => {
  const { icon } = props;
  const classes = useStyles();
  return (
    <Icon classes={{ root: classes.chartIconPlaceholder }}>
      <img className={classes.chartIcon} src={icon} width="26" alt="chart-icon.png" />
    </Icon>
  );
};

const ChartTogglebar = () => {
  const classes = useStyles();
  // const { chartDrawer } = useSelector((state) => state.app);
  // const { setChartDrawerState } = appActions();
  const { chart, city_selected, western_arizona_selected, tribe_selected, is_city, is_tribe, is_western, irrigation_district_selected } = useSelector((state) => state.technical_view);
  const { features } = useSelector((state) => state.featureSettings);
  const { setChart } = userActions();
  const history = useHistory();
  const isDevUrl = useIsDevUrl();
  const [hover, setHover] = useState('')
  let params = new URLSearchParams(history?.location?.search)

  useEffect(() => {
    if(!params.get('dropdown') || !params.get('type') || (params.get('dropdown') === 'undefined')) {
      // let tabValue = history?.location?.pathname?.split('/')[2]   
      let type = 'cities'
      let dropdown = 'Phoenix'
      // Set the 'type' and 'dropdown' parameter
      params.set('type', type);
      params.set('dropdown', dropdown);

      // To update the URL with the new parameters
      history.replace({ search: params.toString() });
    }
  }, [])

  const onChangeTab = (_event, value) => {
    setChart(value);
    /** Set the dropdown value based on the most recently selected entity */
    switch (value) {
      case 'colorado_river_access':
        let dropdownParams = is_city ? {type: 'cities', dropdown: city_selected?.name} : is_tribe ? { type: 'tribe', dropdown: tribe_selected?.name } : {name: 'irrigation_district' , dropdown: western_arizona_selected?.name}
        // includes all entities of types Western Arizona, Irrigation Districts, and Cities.
        history.push({
          pathname: `/visualizations/map`,
          search:  "?" + new URLSearchParams(dropdownParams).toString(),
        });
        break;
      case 'access_per_capita':
        // includes  Cities entity
        history.push({
          pathname: '/visualizations/honeycomb',
          search:  "?" + new URLSearchParams({ type: "cities", dropdown: city_selected?.name || "Phoenix" }).toString(),
        });
        break;
      case 'central_az_water_use':
        // Cities tab: Cities , Irrigations tab : Irrigation
        let obj = is_western ? {type: 'irrigation_district', dropdown: irrigation_district_selected?.name} : {type: 'cities', dropdown: city_selected?.name}
        history.push({
          pathname: `/visualizations/doughnut`,
          search:  "?" + new URLSearchParams(obj).toString(),
        });
        break;
      case 'colorado_river_water_access':
        // includes all entities of types Western Arizona, Irrigation Districts, and Cities.
        history.push({
          pathname: `/visualizations/area`,
          search:  "?" + new URLSearchParams({type: params.get('type') || "cities", dropdown: params.get('dropdown') || "Phoenix"}).toString(),
        });
        break;
      case 'water_use_versus_access':
        // includes  Cities entity
        history.push({
          pathname: `/visualizations/gauge`,
          search:  "?" + new URLSearchParams({ type: "cities", dropdown: city_selected?.name || "Phoenix" }).toString(),
        });
        break;
      default:
        break;
    }
  };

  const handleHover = (value) => {
    setHover(value)
  }

  const renderTabPanel = () => {
    let classNames = {};
    let count = 0;
    const classNamePrefix = "chart-panel-drawer-";
    listOfFeatureSettings.map((tab) => {
      if(features[tab]) {
        count++
        classNames[tab] = classNamePrefix + count
      }
    })

    return (
      <Grid className="main-grid">
        {
          listOfFeatureSettings.map((tab) => {
            return (
              <TabPanel
                value={hover}
                className={
                  hover === TabPanelData[tab]['key']
                    ? classNames[tab]
                    : ""
                }
                label={TabPanelData[tab]['label']}
              >
                {TabPanelData[tab]['value']}
              </TabPanel>
            )
          })
        }
      </Grid>
    );
  };
  return (
    <Grid container item className={classes.chartTogglebar}>
      <Grid item className={classes.chartTogglebarChild}>
        {/* {!chartDrawer ? (
          <img
            src={sidebarExpand}
            className={classes.chartToggleIcon}
            onClick={() => setChartDrawerState()}
          />
        ) : (
          <Grid
            className={classes.chartToggleIcon}
            style={{ marginBottom: 4 }}
          ></Grid>
        )} */}
        <Tabs
          value={chart}
          orientation="vertical"
          className={classes.chartTabs}
          onChange={isDevUrl ? () => {} : onChangeTab}
          onMouseLeave={() => {
            setHover("");
          }}
        >
          {
            listOfFeatureSettings.map((tab) => {
              if(features[tab]) {
                return (
                  <Tab
                    className={classes.chartTab}
                    value={TabPanelData[tab]['key']}
                    icon={<ChartIcon icon={TabPanelData[tab]['icon']} />}
                    onMouseEnter={() => {
                      handleHover(TabPanelData[tab]['key']);
                    }}
                  />
                )
              }
            })
          }
        </Tabs>
      </Grid>
      {renderTabPanel()}
      
    </Grid>
  );
};

export default ChartTogglebar;
